<ppl-dialog [title]="title"
            [width]="width"
            [actionLabel]="actionLabel"
            [actionDisabled]="actionDisabled"
            [actionButtonType]="actionButtonType"
            [loading]="loading || (init$ | async) || (verifying$ | async)"
            (action)="onAction()"
            (cancel)="onCancel()"
            [formGroupNoPadding]="true"
            [formGroup]="form"
            [ngSwitch]="step">
  <div *ngIf="error$ | async as error"
       class="error-container">
    <ppl-error-box [ngSwitch]="error.error">
      <ng-container *ngSwitchCase="TwoFactorError.TOO_MANY_REQUESTS">{{ getRetryAfterMessage(error) }}</ng-container>
      <ng-container *ngSwitchCase="TwoFactorError.INVALID_OR_EXPIRED_TOKEN"
                    i18n="@@Invalid_or_expired_token.">Invalid or expired token.</ng-container>
      <ng-container *ngSwitchDefault
                    i18n="@@Unknown_error.">Unknown error.</ng-container>
    </ppl-error-box>
  </div>
  <ng-container *ngSwitchCase="TwoFactorMethodSetupCommonStep.VERIFY">
    <ppl-two-factor-method-setup-verify formControlName="code"
                                        [showResendCode]="showResendCode"
                                        [sentTo]="initData.setupData.value"
                                        (resendCode)="onResendCode()">
      <div class="verify-status-container"
           ngProjectAs="extra-input-content">
        <ppl-form-control-errors *ngIf="codeFormControl.invalid && (codeFormControl.dirty || codeFormControl.touched)"
                                 [errors]="codeFormControl.errors"></ppl-form-control-errors>
        <div *ngIf="resendSetupToggleSentMessage$ | async"
             class="code-sent-message"
             i18n="@@New_code_was_sent">New code was sent</div>
      </div>
    </ppl-two-factor-method-setup-verify>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-content></ng-content>
  </ng-container>
</ppl-dialog>